export default __webpack_public_path__ + "static/b-and-noble-53cbc1d2ad280b168f9408caf247fbb7.png";